import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ContainerComponent } from './components/container/container.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableComponent } from './components/table/table.component';
import { KeypadComponent } from './components/keypad/keypad.component';
import { DialogoConfirmacionComponent } from './components/dialogoconfirmacion/dialogoconfirmacion.component';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { ExportComponent } from './components/export/export.component';
import { ErrorFormDirective } from './directives/error-form.directive';
import { ErrorControlDirective } from './directives/error-control.directive';
import { MatTableExporterModule } from 'mat-table-exporter';
import { TableresponsiveComponent } from './components/tableresponsive/tableresponsive.component';
import { LineBreakDirective } from './components/line-break.directive';
import { MessageNewComponent } from './components/message/message-new/message-new.component';
import { AlertdialogComponent } from './components/alertdialog/alertdialog.component';
import { DatatableComponent } from './components/datatable/datatable.component';
import { DbTableComponent } from './components/db-table/db-table.component';
import { ReadonlyDataTableComponent } from './components/readonly-data-table/readonly-data-table.component';
import { DialogDetalleComponent } from './components/dialog-detalle/dialog-detalle.component';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatListModule } from '@angular/material/list';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ButtonModule } from 'primeng/button';
import { SkeletonModule } from 'primeng/skeleton';
import { CheckboxModule } from 'primeng/checkbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { ScrollPanelModule } from 'primeng/scrollpanel';
// import { CalendarModule } from 'primeng/calendar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MenuModule } from 'primeng/menu';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { TagModule } from 'primeng/tag';
import { DropdownModule } from 'primeng/dropdown';
import { SliderModule } from 'primeng/slider';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { TooltipModule } from 'primeng/tooltip';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
// import { PickListModule } from 'primeng/picklist';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { PickListModule } from 'primeng/picklist';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ReadonlyDataTableSigleComponent } from './components/readonly-data-table/readonly-data-table-single/readonly-data-table-single.component';
import { DialogService } from 'primeng/dynamicdialog';

@NgModule({
  declarations: [
    ContainerComponent,
    TableComponent,
    KeypadComponent,
    DialogoConfirmacionComponent,
    ConfirmComponent,
    ExportComponent,
    ErrorFormDirective,
    ErrorControlDirective,
    TableresponsiveComponent,
    LineBreakDirective,
    LineBreakDirective,
    MessageNewComponent,
    AlertdialogComponent,
    DatatableComponent,
    DbTableComponent,
    ReadonlyDataTableComponent,
    ReadonlyDataTableSigleComponent,
    DialogDetalleComponent,
    LoadingScreenComponent
  ],
  imports: [
    CommonModule,
    MatSidenavModule,
    MatCardModule,
    FlexLayoutModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatDialogModule,
    MatBottomSheetModule,
    MatListModule,
    MatSelectModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatTableExporterModule,
    FormsModule,
    MatTabsModule,
    MatSortModule,
    TableModule,
    MultiSelectModule,
    TagModule,
    DropdownModule,
    SliderModule,
    ProgressBarModule,
    ButtonModule,
    SkeletonModule,
    CheckboxModule,
    InputNumberModule,
    ScrollPanelModule,
    // CalendarModule,
    // DatePickerModule,
    AutoCompleteModule,
    ReactiveFormsModule,
    MenuModule,
    ContextMenuModule,
    DialogModule,
    ConfirmDialogModule,
    TextareaModule,
    InputTextModule,
    ConfirmPopupModule,
    RadioButtonModule,
    // PickListModule,
    ButtonModule,
    TooltipModule,
    FloatLabelModule,
    SelectModule,
    DatePickerModule,
    IconFieldModule,
    InputIconModule,
    ToastModule,
    PickListModule,
    SplitButtonModule
  ],
  exports: [
    FlexLayoutModule,
    MatSidenavModule,
    MatToolbarModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ContainerComponent,
    ReactiveFormsModule,
    MatTableModule,
    TableComponent,
    KeypadComponent,
    MatTooltipModule,
    MatDialogModule,
    MatSnackBarModule,
    MatBottomSheetModule,
    ExportComponent,
    MatListModule,
    ErrorFormDirective,
    ErrorControlDirective,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatTableExporterModule,
    MatTabsModule,
    TableresponsiveComponent,
    MatProgressSpinnerModule,
    DatatableComponent,
    MatRadioModule,
    DbTableComponent,
    ReadonlyDataTableComponent,
    ReadonlyDataTableSigleComponent,
    // CalendarModule,
    // DropdownModule,
    CheckboxModule,
    RadioButtonModule,
    ButtonModule,
    FloatLabelModule,
    SelectModule,
    DatePickerModule,
    InputTextModule,
    MultiSelectModule,
    OverlayPanelModule,
    ToastModule,
    InputNumberModule
  ],
  providers: [DialogService]
})
export class SharedModule { }
